const options = [{
  id: 'max',
  name: 'Máximo disponível',
}, {
  id: 'min',
  name: 'Mínimo disponível',
}];

export function parsePreferenceLabels(value) {
  const option = options.filter(o => o.id === value);

  if (option.length) {
    return option[0].name;
  }

  return undefined;
}

function camelCaseToSnakeCase(string) {
  return string.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

function snakeCaseToCamelCase(string) {
  return string.replace(/_[a-z]/g, found => `${found.charAt(1).toUpperCase()}`);
}

export function findFilters(queryParameters, filters) {
  const foundFilters = { ...filters };

  Object.keys(queryParameters).forEach((queryParameterKey) => {
    if (queryParameters[queryParameterKey]) {
      const filter = Object.keys(filters)
        .find(filterKey => filterKey === camelCaseToSnakeCase(queryParameterKey));
      if (filter) {
        foundFilters[filter] = queryParameters[queryParameterKey];
        foundFilters[typeof foundFilters.show === 'undefined' ? 'active' : 'show'] = true;
      }
    }
  });

  return foundFilters;
}

export function findQueryParams(filters) {
  const queryParams = {};
  Object.keys(filters).forEach((filterKey) => {
    if (filters[filterKey]) {
      const param = snakeCaseToCamelCase(filterKey);
      queryParams[param] = filters[filterKey];
    }
  });

  return queryParams;
}

export default options;
